<script>
import mixins from '../apimixins'
import TablePaginator from '@components/paginator'
import cloneDeep from 'lodash/cloneDeep'
import api from '@utils/api'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'SupplyForecast',
  components: {
    AdjustColumnsDialog,
    TablePaginator,
  },
  mixins: [mixins],
  data() {
    return {
      modelName: 'SupplyForecast',
      showDialog: false,
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'oil_type', value: 'oil', sortable: true },
        {
          text: 'current_volume',
          value: 'currentVolume',
          sortable: true,
          show: true,
        },
        {
          text: 'average_daily_oil_usage_during_last_month',
          value: 'averageMonth',
          sortable: true,
          show: true,
        },
        {
          text: 'average_daily_oil_usage_during_last_week',
          value: 'averageWeek',
          sortable: true,
          show: true,
        },
        {
          text: 'sufficient_for_days',
          value: 'sufficiency',
          sortable: true,
        },
        {
          text: 'securityStock',
          value: 'securityStock',
          sortable: true,
          show: true,
        },
      ],
      isLoading: false,
      supplyDays: 3,
    }
  },
  mounted() {
    let settingsFromStore = this.getSettingsFromStore()
    if (settingsFromStore) {
      this.supplyDays = settingsFromStore
    }
    this.init()
  },
  methods: {
    submit() {
      this.resetPage()
      this.getDataSet()
    },
    init() {
      this.data = []
      this.loading = true
      this.setSettingsInStore()
      this.getPaginator()
      let filters = this.getFilters()
      if (this.filtersEmpty(filters)) {
        this.getDataSet()
      }
    },
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.supplyDays),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
    async getDataSet() {
      this.isLoading = true
      this.otherParams = { supplyDays: this.supplyDays }
      this.setSettingsInStore()
      this.prepareFilterParams()
      api.getReportData('supply_forecast', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content
        this.isLoading = false
      })
    },
  },
}
</script>

<template>
  <div>
    <v-container fluid>
      <v-layout row>
        <v-flex md2>
          <v-text-field
            v-model.number="supplyDays"
            :label="$t('label__supplyDays')"
            type="number"
          />
        </v-flex>
        <v-flex md2>
          <v-btn
            color="primary"
            @click="submit()"
          >
            {{ $t('buttons__apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td>{{ getValue('goods', props.item.oil) }}</td>
          <td v-if="!hideValues('currentVolume')">{{ `${(props.item.currentVolume / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td v-if="!hideValues('averageMonth')">{{ `${(props.item.averageMonth / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td v-if="!hideValues('averageWeek')">{{ `${(props.item.averageWeek / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td>{{ props.item.sufficiency }}</td>
          <td v-if="!hideValues('securityStock')">{{ props.item.securityStock }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
